import React from 'react';
import { Grid, TextField, Chip, Typography } from '@material-ui/core';
import { injectIntl, IntlShape } from 'react-intl';
import { useSelector } from 'react-redux';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { get } from 'lodash';
import { COLORS } from 'constants/design';
import messages from 'containers/CourtManagerLegalProceedings/ExpertiseExpert/messages';
import { translate } from 'containers/services/translate';
import { StyledGrid } from 'containers/ExpertExpertise/FillExpertise/style';
import Document from 'components/Document';
import { handleOpenDocument } from 'services/utils';
import { MISSION_EXPERISE_VICTIM_STATUS } from 'containers/data-structure';
import { MISSION_EXPERTISE_VICTIM_TYPE } from 'containers/ExpertExpertise/ConcernedExpertise/constants';
import ActionButton from 'containers/CourtManagerLegalProceedings/ExpertiseExpert/ActionButton';
import {
  renderChipLabel,
  renderColor,
} from 'containers/ExpertExpertise/Recap/utils';
import { getValueByCode } from 'containers/common/LegalProceedings/JudgementAdd/Recap/utils';
import { getValueByCode as getValueByCodeSagis } from 'containers/CourtManagerLegalProceedings/Provision/utils';
import LabelValue from 'containers/CourtManagerLegalProceedings/ExpertiseExpert/ExpertReport/LabelValue';

export interface AccountingFormRecapProps {
  intl: IntlShape;
  recap: any;
  isLawyer?: boolean;
  handleOpenDialogValidation: Function;
  handleOpenDialogRejection: Function;
  handleOpenAppreciationDialog: Function;
  isTransaction?: boolean;
  requestGetDocByDocumentumId: Function;
}
const AccountingFormRecap: React.FC<AccountingFormRecapProps> = props => {
  const listings = useSelector((state: any) =>
    get(state.toJS(), ['appContainer', 'listings'], []),
  );
  return (
    <StyledGrid container spacing={3} alignItems="center">
      <Grid item xs={12}>
        {!props.isTransaction && (
          <Grid container spacing={3} alignItems="center">
            <Grid item xs={4}>
              <LabelValue
                title={translate(messages.referenceMisionTitle, props) + ':'}
                value={get(props.recap, 'mission.reference')}
              />
            </Grid>

            {get(props.recap, 'mission.courtFileNumber') && (
              <Grid item xs={4}>
                <LabelValue
                  title={translate(messages.courtFileNumberTitle, props) + ':'}
                  value={get(props.recap, 'mission.courtFileNumber')}
                />
              </Grid>
            )}

            <Grid item xs={4}>
              <LabelValue
                title={translate(messages.procedureTypeTitle, props) + ':'}
                value={
                  getValueByCode(
                    get(props.recap, 'mission.procedureNatureId'),
                    get(listings, 'procedureNature'),
                  ) as any
                }
              />
            </Grid>
          </Grid>
        )}
      </Grid>
      <Grid item xs={4}>
        <TextField
          name="fixedAnnualIncome"
          label={translate(messages.fixedAnnualRevenue, props)}
          defaultValue={props.recap.fixedAnnualIncome}
          type="number"
          fullWidth
          InputProps={{
            disabled: true,
          }}
        />
      </Grid>
      <Grid item xs={4}>
        <TextField
          title={
            get(props.recap, 'type', '') ===
            MISSION_EXPERTISE_VICTIM_TYPE.APPRECIATION
              ? translate(messages.commentAppreciationTitle, props)
              : translate(messages.comment, props)
          }
          label={
            get(props.recap, 'type', '') ===
            MISSION_EXPERTISE_VICTIM_TYPE.APPRECIATION
              ? translate(messages.commentAppreciationTitle, props)
              : translate(messages.comment, props)
          }
          defaultValue={props.recap.comment}
          fullWidth
          InputProps={{
            disabled: true,
          }}
        />
      </Grid>
      {(!props.recap.status ||
        props.recap.status === MISSION_EXPERISE_VICTIM_STATUS.PENDING) && (
        <Grid item xs={4}>
          {!props.isLawyer && (
            <ActionButton
              handleOpenDialogValidation={props.handleOpenDialogValidation}
              handleOpenDialogRejection={props.handleOpenDialogRejection}
              shouldDisplayAppreciation={
                get(props.recap, 'mission.assignedExperts', []).length === 1
              }
              handleOpenAppreciationDialog={props.handleOpenAppreciationDialog}
            />
          )}
        </Grid>
      )}
      <Grid item xs={12}>
        <section>
          {props.recap.document && (
            <div className="support-document-info">
              <Document
                name={get(props.recap.document, 'name', '')}
                type={get(props.recap.document, 'type', '')}
                icon={
                  <VisibilityIcon
                    className="consult"
                    onClick={handleOpenDocument(
                      props.recap.document,
                      props.requestGetDocByDocumentumId,
                    )}
                  />
                }
              />
            </div>
          )}
        </section>
      </Grid>
      <Grid item>
        <Typography
          style={{
            color: COLORS.LIGHT_GREY,
            fontWeight: 400,
            fontSize: '13px',
          }}
        >
          {translate(messages.statusTitle, props)}
        </Typography>
      </Grid>
      <Grid item xs={11}>
        <Chip
          style={{
            backgroundColor: renderColor(props.recap?.status),
            color: COLORS.WHITE,
            fontWeight: 700,
          }}
          label={renderChipLabel(props.recap?.status)}
        />
      </Grid>
      {get(props.recap, 'decisionComment') && (
        <>
          <Grid item>
            <Typography
              style={{
                color: COLORS.LIGHT_GREY,
                fontWeight: 400,
                fontSize: '13px',
              }}
            >
              {translate(messages.comment, props) + ':'}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography
              style={{
                color: COLORS.TEXT_BLACK,
                fontWeight: 400,
                fontSize: '13px',
              }}
            >
              {get(props.recap, 'decisionComment')}
            </Typography>
          </Grid>
        </>
      )}
      {get(props.recap, 'status') === MISSION_EXPERISE_VICTIM_STATUS.REJECTED &&
        get(props.recap, 'rejectionReason') && (
          <>
            <Grid item>
              <Typography
                style={{
                  color: COLORS.LIGHT_GREY,
                  fontWeight: 400,
                  fontSize: '13px',
                }}
              >
                {translate(messages.reason, props) + ':'}
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography
                style={{
                  color: COLORS.TEXT_BLACK,
                  fontWeight: 400,
                  fontSize: '13px',
                }}
              >
                {get(props.recap, 'rejectionReason')}
              </Typography>
            </Grid>
          </>
        )}
      {get(props.recap, 'createdBy') && (
        <>
          <Grid item>
            <Typography
              style={{
                color: COLORS.LIGHT_GREY,
                fontWeight: 400,
                fontSize: '13px',
              }}
            >
              {translate(messages.createdByTitle, props)}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography
              style={{
                color: COLORS.TEXT_BLACK,
                fontWeight: 400,
                fontSize: '13px',
              }}
            >
              {getValueByCodeSagis(
                get(props.recap, 'createdBy') as string,
                get(listings, 'intervenants'),
              )}
            </Typography>
          </Grid>
        </>
      )}
    </StyledGrid>
  );
};

export default injectIntl(AccountingFormRecap);
